var map = {
	"./vector-1.svg": 7087,
	"./vector-2.svg": 4412,
	"./vector-3.svg": 8685,
	"./vector-4.svg": 4754,
	"./vector-5.svg": 2691,
	"./vector-6.svg": 7552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7609;